import { createStructuredSelector } from 'reselect'
import { isUserLoggedIn, isAuthInProgress, authError } from '../../redux/selectors/auth'
import { loginThunk } from '../../redux/thunks/auth'
import Auth from '../../redux/auth'

export const mapStateToProps = createStructuredSelector({
  isAuthInProgress,
  isUserLoggedIn,
  error: authError,
})

export const mapDispatchToProps = {
  login: loginThunk,
  resetAuth: Auth.clear,
}
